import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined';
import FileProtectOutlined from '@ant-design/icons/FileProtectOutlined';
import ShoppingOutlined from '@ant-design/icons/ShoppingOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import BarChartOutlined from '@ant-design/icons/BarChartOutlined';

const comercial = {
  id: 'group-comercial',
  title: 'Comercial',
  type: 'group',
  children: [
    {
      id: 'back-to-core',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'comercial-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/comercial/dashboard',
      icon: DashboardOutlined,
      permissions: ['comercial.dashboard.view'],
      breadcrumbs: false
    },
    {
      id: 'comercial-propostas',
      title: 'Propostas',
      type: 'item',
      url: '/comercial/propostas',
      icon: FileDoneOutlined,
      permissions: ['comercial.propostas.view'],
      breadcrumbs: false
    },
    {
      id: 'comercial-contratos',
      title: 'Contratos',
      type: 'item',
      url: '/comercial/contratos',
      icon: FileProtectOutlined,
      permissions: ['comercial.contratos.view'],
      breadcrumbs: false
    },
    {
      id: 'comercial-catalogo-auxiliar',
      title: 'Catálogo Auxiliar',
      type: 'collapse',
      icon: ShoppingOutlined,
      children: [
        {
          id: 'comercial-produtos',
          title: 'Produtos e Serviços',
          type: 'item',
          url: '/comercial/produtos',
          permissions: ['comercial.produtos.view'],
          breadcrumbs: false
        },
        {
          id: 'comercial-produto-familias',
          title: 'Famílias de Produto',
          type: 'item',
          url: '/comercial/produto-familias',
          permissions: ['comercial.produtos.view'],
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'comercial-relatorios',
      title: 'Relatórios',
      type: 'collapse',
      icon: BarChartOutlined,
      children: [
        {
          id: 'comercial-relatorio-glpi',
          title: 'GLPI',
          type: 'item',
          url: '/comercial/relatorios/glpi',
          permissions: ['comercial.contratos.view'],
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'comercial-configuracoes',
      title: 'Configurações',
      type: 'collapse',
      icon: SettingOutlined,
      children: [
        {
          id: 'comercial-regras-aprovacao',
          title: 'Regras de Aprovação',
          type: 'item',
          url: '/comercial/configuracoes/regras-aprovacao',
          permissions: ['comercial.regras-aprovacao.view'],
          breadcrumbs: false
        },
        {
          id: 'comercial-biblioteca-clausulas',
          title: 'Biblioteca de Cláusulas',
          type: 'item',
          url: '/comercial/configuracoes/biblioteca-clausulas',
          permissions: ['comercial.biblioteca-clausulas.view'],
          breadcrumbs: false
        },
        {
          id: 'comercial-contrato-templates',
          title: 'Modelos de Contrato',
          type: 'item',
          url: '/comercial/configuracoes/contrato-templates',
          permissions: ['comercial.templates.view'],
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default comercial;
